// @ts-check
import React, { Component } from 'react';
import LoadingContent from 'shared/components/LoadingContent';
import api from 'utils/api';
import ReferralQuestionnaire from './ReferralQuestionnaire';

class AsyncReferralQuestionnaire extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { questionnaire: null };
  }

  componentDidMount() {
    api.get(`/agent_portal/api/referrals/${this.props.referralId}/questionnaire`).then(response => {
      this.setState({ questionnaire: response.data });
    });
  }

  render() {
    if (!this.state.questionnaire) return <LoadingContent />;
    return (
      <div>
        <div className="modal-header">
          <h3>Questionnaire</h3>
        </div>
        <div className="modal-body" style={{ overflowY: 'scroll', maxHeight: '600px' }}>
          <ReferralQuestionnaire
            pdfUrl={`/agent_portal/referrals/${this.props.referralId}/questionnaire_response.pdf`}
            questionnaire={this.state.questionnaire}
          />
        </div>
      </div>
    );
  }
}

export default AsyncReferralQuestionnaire;
